<div class="spinner-wrapper"><mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner></div>
